import type { Fragment } from '../translations';

export const repertoire: Fragment = {
  fr: {
    'rep.allProcesses': 'Tous les processus',
    'rep.root': '(racine)',
    'rep.count': '{n} processus',
    'rep.searchPlaceholder': 'Rechercher un processus, un rôle, une tâche…',
    'rep.groupVersions': 'Grouper les versions',
    'rep.new': 'Nouveau processus',
    'rep.filter.all': 'Tous',
    'rep.filter.live': 'En service',
    'rep.filter.cycle': 'En cycle',
    'rep.filter.documented': 'Documenté',
    'rep.filter.toModel': 'À modéliser',
    'rep.filter.tickets': 'Tickets',
    'rep.state.live': 'En service',
    'rep.state.documented': 'Documenté',
    'rep.state.toModel': 'À modéliser',
    'rep.state.draft': 'Brouillon',
    'rep.state.superseded': 'Remplacé par {code}',
    'rep.state.supersededBare': 'Remplacé',
    'rep.colCode': 'Code',
    'rep.state.step': 'Étape {n}',
    'rep.state.unreadable': 'Illisible',
    'rep.chip.duplicate': 'Doublon',
    'rep.chip.duplicateDivergent': 'Doublon divergent',
    'rep.chip.technical': 'Fichier technique',
    'rep.chip.duplicateTip': 'Existe aussi : {paths}',
    'rep.documentedTip': 'Modèle existant, pas encore passé par le cycle CdE.',
    'rep.toModelTip': 'Fichier vide — le nom est réservé, le modèle reste à faire.',
    'rep.draftTip': 'Enregistrement de cycle sans fichier lié — emplacement prévu.',
    'rep.col.process': 'Processus',
    'rep.col.state': 'État',
    'rep.col.owner': 'Responsable',
    'rep.col.functions': 'Fonctions',
    'rep.col.roles': 'Rôles',
    'rep.col.modified': 'Dernière modif.',
    'rep.rolesCount': '{n} rôles',
    'rep.emptyDomain': 'Aucun processus dans ce domaine.',
    'rep.emptyDomainCta': 'Créer le premier',
    'rep.noResults': 'Aucun processus ne correspond à « {q} ».',
    'rep.noResultsHint': 'Essayez le nom d\'un rôle (ex. Secrétariat) ou d\'une étape (ex. facture).',
    'rep.repoDown': 'Le dépôt de processus est momentanément injoignable. Les processus en cycle restent consultables.',
    'rep.syncedAgo': 'synchronisé il y a {when}',
    'rep.openGithub': 'Ouvrir dans GitHub',
    'rep.branch': 'branche {branch}',
    'rep.openCycle': 'Ouvrir un cycle sur ce processus',
    'rep.reportProblem': 'Signaler un problème',
    'rep.justNow': 'à l\'instant',
    'rep.minutesAgo': '{n} min',
  },
  en: {
    'rep.allProcesses': 'All processes',
    'rep.root': '(root)',
    'rep.count': '{n} processes',
    'rep.searchPlaceholder': 'Search a process, a role, a task…',
    'rep.groupVersions': 'Group versions',
    'rep.new': 'New process',
    'rep.filter.all': 'All',
    'rep.filter.live': 'Live',
    'rep.filter.cycle': 'In cycle',
    'rep.filter.documented': 'Documented',
    'rep.filter.toModel': 'To model',
    'rep.filter.tickets': 'Tickets',
    'rep.state.live': 'Live',
    'rep.state.documented': 'Documented',
    'rep.state.toModel': 'To model',
    'rep.state.draft': 'Draft',
    'rep.state.superseded': 'Superseded by {code}',
    'rep.state.supersededBare': 'Superseded',
    'rep.colCode': 'Code',
    'rep.state.step': 'Step {n}',
    'rep.state.unreadable': 'Unreadable',
    'rep.chip.duplicate': 'Duplicate',
    'rep.chip.duplicateDivergent': 'Divergent duplicate',
    'rep.chip.technical': 'Technical file',
    'rep.chip.duplicateTip': 'Also exists: {paths}',
    'rep.documentedTip': 'Existing model, not yet through the CdE cycle.',
    'rep.toModelTip': 'Empty file — the name is reserved, the model remains to be made.',
    'rep.draftTip': 'Cycle record with no linked file — intended location.',
    'rep.col.process': 'Process',
    'rep.col.state': 'State',
    'rep.col.owner': 'Owner',
    'rep.col.functions': 'Functions',
    'rep.col.roles': 'Roles',
    'rep.col.modified': 'Last modified',
    'rep.rolesCount': '{n} roles',
    'rep.emptyDomain': 'No processes in this domain.',
    'rep.emptyDomainCta': 'Create the first',
    'rep.noResults': 'No process matches "{q}".',
    'rep.noResultsHint': 'Try a role name (e.g. Secrétariat) or a task (e.g. facture).',
    'rep.repoDown': 'The process repository is temporarily unreachable. Processes in cycle remain available.',
    'rep.syncedAgo': 'synced {when} ago',
    'rep.openGithub': 'Open in GitHub',
    'rep.branch': 'branch {branch}',
    'rep.openCycle': 'Open a cycle on this process',
    'rep.reportProblem': 'Report a problem',
    'rep.justNow': 'just now',
    'rep.minutesAgo': '{n} min',
  },
};
